import { CardHeader, CardHeaderProps } from "reactstrap"
import styled from "@emotion/styled"

export type TooltipTitleProps = CardHeaderProps

export const TooltipTitle = styled(CardHeader)`
  background: white;
  font-weight: bold;
`
